import { createAction } from '@reduxjs/toolkit';
import { GlobalState } from '../types.global';

export const browserStorageUpdate = createAction<{ state: GlobalState, isNewer: boolean }>('BROWSER_STORAGE_UPDATE');